var modules_7ff94741 = {"supportTitle":"Support_module_supportTitle__118cb6a4","supportHelp":"Support_module_supportHelp__118cb6a4"};
import "../../assets/BLPUN0JZ.css";

export { modules_7ff94741 as default };
//# sourceMappingURL=Support.module.less.js.map
